export default "__VITE_ASSET__Ccn1QWpy__"